<template>
    <div class="self-select-box">
        <div class="frame-input" @click.stop="changeOptions" :class="{'active':isOpen}">
            <i class="el-icon-arrow-up" :class="{'tranform-active':isOpen}"></i>
        </div>
        <transition>
            <div class="options-box" @click.stop v-if="isOpen">
            <div class="search-box">
                <el-input v-model="keywords" @clear="changeCurrent(1)" @input="changeCurrent(1)" clearable @keydown.enter.native="changeCurrent(1)" placeholder="请输入搜索关键字">
                    <el-button @click="changeCurrent(1)" slot="append" icon="el-icon-search"></el-button>
                </el-input>
            </div>
            <no-data v-if="selectList.length==0"></no-data>
            <div class="option-box" v-else>
                <div class="select-item" v-for="(item,index) in selectList" @click.stop="chooseItem(item)" :class="{'select-active':item.value==value}" :key="index">{{ item.label }}</div>
            </div>
            <div class="page-box">
                <el-pagination
                small
                layout="prev, pager, next"
                :current-page="current"
                :page-size="size"
                :current-change="changeCurrent"
                :total="total">
                </el-pagination>
            </div>
        </div>
        </transition>
    </div>
</template>

<script>
import NoData from './NoData.vue';
export default {
  components: { NoData },
        props:{
            selectList:{
                require:true,
                type:Array,
                default:()=>[],
            },
            value:{
                require:true,
            },
            total:{
                require:true,
                type:Number,
                default:0
            }
        },
        data(){
            return {
                /**展开选项 */
                isOpen:false,
                /**模糊查询关键字 */
                keywords:'',
                current:1,
                size:10,
            }
        },
        methods:{
            changeOptions(){
                this.isOpen=!this.isOpen;
            },
            closeOption(){
                this.isOpen=false;
            },
            changeCurrent(e){
                this.current=e;
                this.$emit('change_current',{
                    keywords:this.keywords,
                    size:this.size,
                    current:this.current
                });
            },
            chooseItem(item){
                this.$emit('input',item.value);
                this.closeOption();
            }
        },
        mounted(){
            window.addEventListener('click',this.closeOption);
        },
        destroyed(){
            window.removeEventListener('click',this.closeOption);
        }
    }
</script>

<style lang="less" scoped>
.active{
    border-color: #409eff !important;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
.tranform-active{
    transform: rotate(0deg) !important;
}
.select-active{
    color: #409eff !important;
    font-weight: 500;
    background-color: #ecf5ff;
}
.frame-input{
    width: 25rem;
    height: 3.5rem;
    border: 1px solid rgb(220, 223, 230);
    border-radius: 4px;
    padding: 0 1.5rem 3rem;
    position: relative;
    z-index: 99;
}
.el-icon-arrow-up{
    color: rgb(192, 196, 204);
    font-size: 1.8rem;
    position: absolute;
    top: 0.8rem;
    right:1rem;
    transform: rotate(180deg);
    transition: all 0.3s;
}
.self-select-box{
    position: relative;
    display: inline-block;
    color: #334681;
}
.options-box{
    overflow: hidden;
    z-index: 999;
    position: absolute;
    width: calc(100% - 1rem);
    left: 0.5rem;
    top: calc(100% + 5px);
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .search-box{
        padding: 1rem;
        border-bottom: 1px solid #e4e7ed;
    }
    .option-box{
        max-height: 25rem;
        overflow-y: auto;
        .select-item{
            padding: 10px 16px;
            cursor: pointer;
            transition: all 0.3s;
        }
        .select-item:hover{
            background-color: #ecf5ff;
        }
    }
    .page-box{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        border-top: 1px solid #e4e7ed;
    }
}
.v-enter-active{
  animation:enter 0.3s linear;
}
.v-leave-active{
  animation:leave 0.3s linear;
}
@keyframes enter{
    0%{
        opacity: 0;
    }
    100%{
        opacity: 1;
    }
}
@keyframes leave{
    0%{
        opacity: 1;
    }
    100%{
        opacity: 0;
    }
}
</style>